import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import CustomTable from '../../custom-table/CustomTable';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';
import useLog from '../../../hooks/useLog';
import { getDateFormatted } from '../../../utils/dateUtils';
import { setShowApplicationLogsModal } from '../../../slice/showModalSlice';
import LoadSpinner from '../../load-spinner/LoadSpinner';


const ApplicationLogsModal = () => {
  const [logs, setLogs] = useState([])
  const logTableHeader = [
  { label: 'Data', field: 'creationDate' },
  { label: 'Livello', field: 'level' },
  { label: 'Messaggio', field: 'message' },
  { label: 'Descrizione', field: 'description' },
];

const { getApplicationLogs, logLoading } = useLog();

const dispatch = useDispatch();

const show = useSelector((state) => state.showModal.showApplicationLogsModal);
const selectedUser = useSelector((state) => state.editUser.selectedUser);


useEffect(() => {
  if( show && selectedUser ){
     getApplicationLogs(
      selectedUser.username,
      (data) => {
        data.forEach((log) => {
          log.creationDate = getDateFormatted(log.creationDate, "DD/MM/YYYY HH:mm");
        });
        setLogs(data)
      },
      () => toast.error("Errore nel ricevere i log")
     );
  }
}, [show,selectedUser]);



const downloadEXcel = () =>{
    try{
      const fieldMappingsSheet1 = [
        { key: 'creationDate', name: 'Data' },
        { key: 'level', name: 'Livello' },
        { key: 'message', name: 'Messaggio' },
        { key: 'description', name: 'Descrizione' },
        { key: 'rowError', name: 'Riga' },
        { key: 'body', name: 'Body' },
        { key: 'deviceId', name:'ID Dispositivo' },
        { key: 'uwbId', name:'ID UWB' },
        { key: 'username', name:'Username' },
      ];


      const renameKeys = (obj, keyMap) =>
      Object.keys(obj).reduce((acc, key) => {
        const mapping = keyMap.find(item => item.key === key);
        if (mapping) {
          const renamedKey = mapping.name;
          return { ...acc, [renamedKey]: obj[key] };
        }
        return acc;
      }, {});

      const workbook = XLSX.utils.book_new();
        const sheet1Dati = logs.map(item =>renameKeys(item,fieldMappingsSheet1))
        const sheet1 = XLSX.utils.json_to_sheet(sheet1Dati);
        XLSX.utils.book_append_sheet(workbook, sheet1, 'Logs');

        XLSX.writeFile(workbook, `Esportazione_log.xlsx`);
    } catch (error) {
      console.error("Errore durante il download del file Excel:", error);
      toast.error("Errore durante il download del file Excel");}
      };

      const handleClose = () => {
        dispatch(setShowApplicationLogsModal());
        setLogs([]);
      }

  return (
    <Modal show={show} size="xl" onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Log</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {logLoading 
        ?<LoadSpinner/> 
        :<CustomTable
          header={logTableHeader}
          data={logs}
          label='Record'
          noClick={true}
          />
        }
      </Modal.Body>
      <Modal.Footer >
        <Button className='btn-green' onClick={downloadEXcel}>
          Scarica logs
        </Button>
        <Button variant="secondary" onClick={handleClose}>
          Chiudi
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ApplicationLogsModal;
